import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

import breakpoints from '@rsc/ui-components/breakpoints';
import sharedStyles from '@rsc/ui-components/styles';

import backgroundImage from './bg-body.jpg';
import mobileBackgroundImage from './bg-body-mobile.jpg';
import styles from './styles';

const GlobalStyles = createGlobalStyle`
  html, body {
    text-rendering: optimizeLegibility;
    background: ${props =>
      props.isIframe
        ? styles.colors.gray[900]
        : `${styles.colors.black} url(${mobileBackgroundImage})`};

    @media screen and (min-width: ${breakpoints.md}) {
      background: ${props =>
        props.isIframe
          ? styles.colors.gray[900]
          : `${styles.colors.black} url(${backgroundImage}) fixed center`};

    }
  }

  *, *::before, *::after {
    box-sizing: inherit;
    line-height: inherit;
  }

  /* this is needed to make styled inputs work on Safari 🤷
  https://stackoverflow.com/questions/49889003/cannot-write-into-input-field-on-safari */
  input, input:before, input:after {
    -webkit-user-select: initial;
    -khtml-user-select: initial;
    -moz-user-select: initial;
    -ms-user-select: initial;
    user-select: initial;
  }

  a {
    &:hover {
      text-decoration: none;
    }
  }

  strong {
    font-style: inherit;
    font-weight: 700;
  }

  sup {
    top: revert;
    vertical-align: super;
    font-size: 75%;
  }

  ol {
    list-style-type: decimal;
    margin-left: ${sharedStyles.spacing['spacing-md']};

    @media screen and (min-width: ${breakpoints.md}){
      margin-left: 0;
    }
  }

  ol li {
    margin-bottom: ${sharedStyles.spacing['spacing-md']};
  }

  input, select, textarea {
    background-color: white;
    border: 1px solid ${styles.colors.gray[300]};
    font-family: inherit;
  }

`;

// styles specfically for SSO site
const LegacyStyles = createGlobalStyle` 

 @font-face {
    font-family: 'ronnia-condensed';
    src: url('https://use.typekit.net/af/1350a7/0000000000000000000141c5/27/l?primer=81a69539b194230396845be9681d114557adfb35f4cccc679c164afb4aa47365&fvd=n4&v=3')
        format("woff2"),
      url('https://use.typekit.net/af/1350a7/0000000000000000000141c5/27/d?primer=81a69539b194230396845be9681d114557adfb35f4cccc679c164afb4aa47365&fvd=n4&v=3')
        format("woff"),
      url('https://use.typekit.net/af/1350a7/0000000000000000000141c5/27/a?primer=81a69539b194230396845be9681d114557adfb35f4cccc679c164afb4aa47365&fvd=n4&v=3')
        format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: 'ronnia';
    src: url('https://use.typekit.net/af/10fd19/000000000000000000011f36/27/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3')
        format("woff2"),
      url('https://use.typekit.net/af/10fd19/000000000000000000011f36/27/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3')
        format("woff"),
      url('https://use.typekit.net/af/10fd19/000000000000000000011f36/27/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n4&v=3')
        format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: 'ronnia';
    src: url('https://use.typekit.net/af/c4d011/000000000000000000011f37/27/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i4&v=3')
        format("woff2"),
      url('https://use.typekit.net/af/c4d011/000000000000000000011f37/27/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i4&v=3')
        format("woff"),
      url('https://use.typekit.net/af/c4d011/000000000000000000011f37/27/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i4&v=3')
        format("opentype");
    font-display: auto;
    font-style: italic;
    font-weight: 400;
  }
  @font-face {
    font-family: 'ronnia';
    src: url('https://use.typekit.net/af/83efcf/000000000000000000011f38/27/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n7&v=3')
        format("woff2"),
      url('https://use.typekit.net/af/83efcf/000000000000000000011f38/27/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n7&v=3')
        format("woff"),
      url('https://use.typekit.net/af/83efcf/000000000000000000011f38/27/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=n7&v=3')
        format("opentype");
    font-display: auto;
    font-style: normal;
    font-weight: 700;
  }
  @font-face {
    font-family: 'ronnia';
    src: url('https://use.typekit.net/af/ed3562/000000000000000000011f39/27/l?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i7&v=3')
        format("woff2"),
      url('https://use.typekit.net/af/ed3562/000000000000000000011f39/27/d?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i7&v=3')
        format("woff"),
      url('https://use.typekit.net/af/ed3562/000000000000000000011f39/27/a?primer=7fa3915bdafdf03041871920a205bef951d72bf64dd4c4460fb992e3ecc3a862&fvd=i7&v=3')
        format("opentype");
    font-display: auto;
    font-style: italic;
    font-weight: 700;
  }


  ${normalize};

  html, body {
    font-size: ${sharedStyles.fontSize.base};
    font-family: ronnia, helvetica, sans-serif;
    line-height: 1.5;
    box-sizing: border-box;
    color: ${styles.colors.white};
  }

  a {
    color: ${styles.colors.orange[600]};
  }

  p {
    margin: 0 0 1em;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;;
    line-height: 1.15;
    margin: 0 0 0.25em;
  }
`;

export { LegacyStyles, GlobalStyles };
